module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_6.47b745e4.jpg";